export default __webpack_public_path__ + "static/media/swing_off.9bbf54b1.svg";